"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchRecordingUpdate = dispatchRecordingUpdate;
exports.handleClientMethods = exports.getClientMethodFromTags = void 0;
exports.handleStopStreams = handleStopStreams;
exports.handleTaskStateMessage = handleTaskStateMessage;
exports.parseIfJSON = exports.isValidClientMethod = void 0;
exports.updateStreamStatus = updateStreamStatus;
var _types = require("../actions/recording/types");
var _types2 = require("../actions/stream/types");
var _streamHelper = require("./streamHelper");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LOG = new _StudioLogger.StudioLogger('realtimeUtils');
var handleClientMethods = exports.handleClientMethods = function handleClientMethods(clientMethod, store, snsMessage, setStreamStatus) {
  if (!isValidClientMethod(clientMethod)) {
    return;
  }
  switch (clientMethod) {
    case 'client:broadcast.updateStreamEndpointTaskState':
    case 'client:broadcast.updateRecordingTaskState':
      handleTaskStateMessage(store, snsMessage, setStreamStatus);
      break;
    case 'client:broadcast.stopStreams':
      handleStopStreams(store, snsMessage, setStreamStatus);
      break;
    default:
      break;
  }
};
function handleTaskStateMessage(store, snsMessage, setStreamStatus) {
  var taskPayload = snsMessage.payload,
    responsePayload = snsMessage.responsePayload;
  if (!(taskPayload !== null && taskPayload !== void 0 && taskPayload.taskState)) {
    return;
  }
  var endpoint = responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.endpoint;
  if (endpoint) {
    store.dispatch({
      type: _types2.BROADCAST_UPDATE_STREAM_REALTIME,
      payload: _objectSpread(_objectSpread({}, responsePayload.endpoint), {}, {
        canStartStream: taskPayload.taskState === 'STOPPED'
      })
    });
    LOG.info("Update stream status to ".concat(endpoint.status, " for endpointId: ").concat(endpoint._id));
  } else {
    var recording = responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.recording;
    var baseRecording = responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.baseRecording;
    dispatchRecordingUpdate(store, recording);
    dispatchRecordingUpdate(store, baseRecording);
    LOG.info("Update recording status to ".concat(recording === null || recording === void 0 ? void 0 : recording.status, " for recordingId: ").concat(recording === null || recording === void 0 ? void 0 : recording._id));
  }
  updateStreamStatus(store, setStreamStatus);
}
function handleStopStreams(store, snsMessage, setStreamStatus) {
  var _snsMessage$payload, _state$broadcast;
  var endpoints = (snsMessage === null || snsMessage === void 0 || (_snsMessage$payload = snsMessage.payload) === null || _snsMessage$payload === void 0 ? void 0 : _snsMessage$payload.endpoints) || [];
  if (!endpoints.length) {
    return;
  }
  var state = store.getState();
  var currentEndpoints = ((_state$broadcast = state.broadcast) === null || _state$broadcast === void 0 ? void 0 : _state$broadcast.endpoints) || state.streamEndpoints || [];
  var stoppedEndpoints = currentEndpoints.filter(function (endpoint) {
    return endpoints.includes(endpoint._id);
  }).map(function (ep) {
    return _objectSpread(_objectSpread({}, ep), {}, {
      canStartStream: false
    });
  });
  stoppedEndpoints.forEach(function (stoppedEndpoint) {
    store.dispatch({
      type: _types2.BROADCAST_UPDATE_STREAM_REALTIME,
      payload: stoppedEndpoint
    });
  });
  updateStreamStatus(store, setStreamStatus);
}
function dispatchRecordingUpdate(store, recording) {
  if (!recording) {
    return;
  }
  store.dispatch({
    type: _types.BROADCAST_UPDATE_RECORDING_REALTIME,
    payload: recording
  });
}
function updateStreamStatus(store, setStreamStatus) {
  var state = store.getState();
  var broadcast = state.broadcast;
  var _ref = broadcast || {},
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? [] : _ref$endpoints,
    _ref$recordings = _ref.recordings,
    recordings = _ref$recordings === void 0 ? [] : _ref$recordings;
  var streamingStatus = (0, _streamHelper.getStreamingStatus)(endpoints);
  var recordingStatus = (0, _streamHelper.getRecordingStatus)(recordings);
  var newStreamStatus = {
    isStreaming: streamingStatus,
    isRecording: recordingStatus
  };
  store.dispatch(setStreamStatus(newStreamStatus));
}
var getClientMethodFromTags = exports.getClientMethodFromTags = function getClientMethodFromTags(tags) {
  return Array.isArray(tags) ? tags.find(function (tag) {
    return isValidClientMethod(tag);
  }) : undefined;
};
var parseIfJSON = exports.parseIfJSON = function parseIfJSON(message) {
  if (typeof message !== 'string') {
    return message;
  }
  try {
    return JSON.parse(message);
  } catch (error) {
    return message;
  }
};
var isValidClientMethod = exports.isValidClientMethod = function isValidClientMethod(clientMethod) {
  return clientMethod && typeof clientMethod === 'string' && clientMethod.includes('client:');
};